function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M66.0492 98.4442C93.2333 98.4442 115.27 76.4067 115.27 49.2221C115.27 22.0375 93.2333 0 66.0492 0C38.8652 0 16.8281 22.0375 16.8281 49.2221C16.8281 76.4067 38.8652 98.4442 66.0492 98.4442Z",
  fill: "url(#paint0_linear_805_42721)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M160.328 135.18H188.387C198.081 135.18 205.94 143.039 205.94 152.733H177.881C168.187 152.733 160.328 144.874 160.328 135.18Z",
  fill: "url(#paint1_linear_805_42721)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M206.12 152.649C206.12 137.232 206.12 117.741 206.12 107.673C193.623 107.673 183.492 117.741 183.492 130.161C183.492 142.581 193.623 152.649 206.12 152.649Z",
  fill: "url(#paint2_linear_805_42721)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M120.231 128.089C120.672 128.089 121.029 127.732 121.029 127.291C121.029 126.851 120.672 126.494 120.231 126.494C119.791 126.494 119.434 126.851 119.434 127.291C119.434 127.732 119.791 128.089 120.231 128.089ZM121.029 130.483C121.029 130.923 120.672 131.28 120.231 131.28C119.791 131.28 119.434 130.923 119.434 130.483C119.434 130.042 119.791 129.685 120.231 129.685C120.672 129.685 121.029 130.042 121.029 130.483ZM120.231 134.472C120.672 134.472 121.029 134.114 121.029 133.674C121.029 133.233 120.672 132.876 120.231 132.876C119.791 132.876 119.434 133.233 119.434 133.674C119.434 134.114 119.791 134.472 120.231 134.472ZM121.029 136.865C121.029 137.305 120.672 137.663 120.231 137.663C119.791 137.663 119.434 137.305 119.434 136.865C119.434 136.424 119.791 136.067 120.231 136.067C120.672 136.067 121.029 136.424 121.029 136.865ZM120.231 140.854C120.672 140.854 121.029 140.497 121.029 140.056C121.029 139.615 120.672 139.258 120.231 139.258C119.791 139.258 119.434 139.615 119.434 140.056C119.434 140.497 119.791 140.854 120.231 140.854ZM120.231 144.045C120.672 144.045 121.029 143.688 121.029 143.247C121.029 142.807 120.672 142.449 120.231 142.449C119.791 142.449 119.434 142.807 119.434 143.247C119.434 143.688 119.791 144.045 120.231 144.045ZM124.22 143.247C124.22 143.688 123.863 144.045 123.423 144.045C122.982 144.045 122.625 143.688 122.625 143.247C122.625 142.807 122.982 142.449 123.423 142.449C123.863 142.449 124.22 142.807 124.22 143.247ZM123.423 140.854C123.863 140.854 124.22 140.497 124.22 140.056C124.22 139.615 123.863 139.258 123.423 139.258C122.982 139.258 122.625 139.615 122.625 140.056C122.625 140.497 122.982 140.854 123.423 140.854ZM124.22 136.865C124.22 137.305 123.863 137.663 123.423 137.663C122.982 137.663 122.625 137.305 122.625 136.865C122.625 136.424 122.982 136.067 123.423 136.067C123.863 136.067 124.22 136.424 124.22 136.865ZM123.423 134.472C123.863 134.472 124.22 134.114 124.22 133.674C124.22 133.233 123.863 132.876 123.423 132.876C122.982 132.876 122.625 133.233 122.625 133.674C122.625 134.114 122.982 134.472 123.423 134.472ZM124.22 130.483C124.22 130.923 123.863 131.28 123.423 131.28C122.982 131.28 122.625 130.923 122.625 130.483C122.625 130.042 122.982 129.685 123.423 129.685C123.863 129.685 124.22 130.042 124.22 130.483ZM123.423 128.089C123.863 128.089 124.22 127.732 124.22 127.291C124.22 126.851 123.863 126.494 123.423 126.494C122.982 126.494 122.625 126.851 122.625 127.291C122.625 127.732 122.982 128.089 123.423 128.089ZM127.412 143.247C127.412 143.688 127.055 144.045 126.614 144.045C126.173 144.045 125.816 143.688 125.816 143.247C125.816 142.807 126.173 142.449 126.614 142.449C127.055 142.449 127.412 142.807 127.412 143.247ZM126.614 140.854C127.055 140.854 127.412 140.497 127.412 140.056C127.412 139.615 127.055 139.258 126.614 139.258C126.173 139.258 125.816 139.615 125.816 140.056C125.816 140.497 126.173 140.854 126.614 140.854ZM127.412 136.865C127.412 137.305 127.055 137.663 126.614 137.663C126.173 137.663 125.816 137.305 125.816 136.865C125.816 136.424 126.173 136.067 126.614 136.067C127.055 136.067 127.412 136.424 127.412 136.865ZM126.614 134.472C127.055 134.472 127.412 134.114 127.412 133.674C127.412 133.233 127.055 132.876 126.614 132.876C126.173 132.876 125.816 133.233 125.816 133.674C125.816 134.114 126.173 134.472 126.614 134.472ZM127.412 130.483C127.412 130.923 127.055 131.28 126.614 131.28C126.173 131.28 125.816 130.923 125.816 130.483C125.816 130.042 126.173 129.685 126.614 129.685C127.055 129.685 127.412 130.042 127.412 130.483ZM126.614 128.089C127.055 128.089 127.412 127.732 127.412 127.291C127.412 126.851 127.055 126.494 126.614 126.494C126.173 126.494 125.816 126.851 125.816 127.291C125.816 127.732 126.173 128.089 126.614 128.089ZM130.603 143.247C130.603 143.688 130.246 144.045 129.805 144.045C129.365 144.045 129.007 143.688 129.007 143.247C129.007 142.807 129.365 142.449 129.805 142.449C130.246 142.449 130.603 142.807 130.603 143.247ZM129.805 140.854C130.246 140.854 130.603 140.497 130.603 140.056C130.603 139.615 130.246 139.258 129.805 139.258C129.365 139.258 129.007 139.615 129.007 140.056C129.007 140.497 129.365 140.854 129.805 140.854ZM130.603 136.865C130.603 137.305 130.246 137.663 129.805 137.663C129.365 137.663 129.007 137.305 129.007 136.865C129.007 136.424 129.365 136.067 129.805 136.067C130.246 136.067 130.603 136.424 130.603 136.865ZM129.805 134.472C130.246 134.472 130.603 134.114 130.603 133.674C130.603 133.233 130.246 132.876 129.805 132.876C129.365 132.876 129.007 133.233 129.007 133.674C129.007 134.114 129.365 134.472 129.805 134.472ZM130.603 130.483C130.603 130.923 130.246 131.28 129.805 131.28C129.365 131.28 129.007 130.923 129.007 130.483C129.007 130.042 129.365 129.685 129.805 129.685C130.246 129.685 130.603 130.042 130.603 130.483ZM129.805 128.089C130.246 128.089 130.603 127.732 130.603 127.291C130.603 126.851 130.246 126.494 129.805 126.494C129.365 126.494 129.007 126.851 129.007 127.291C129.007 127.732 129.365 128.089 129.805 128.089ZM133.794 143.247C133.794 143.688 133.437 144.045 132.996 144.045C132.556 144.045 132.199 143.688 132.199 143.247C132.199 142.807 132.556 142.449 132.996 142.449C133.437 142.449 133.794 142.807 133.794 143.247ZM132.996 140.854C133.437 140.854 133.794 140.497 133.794 140.056C133.794 139.615 133.437 139.258 132.996 139.258C132.556 139.258 132.199 139.615 132.199 140.056C132.199 140.497 132.556 140.854 132.996 140.854ZM133.794 136.865C133.794 137.305 133.437 137.663 132.996 137.663C132.556 137.663 132.199 137.305 132.199 136.865C132.199 136.424 132.556 136.067 132.996 136.067C133.437 136.067 133.794 136.424 133.794 136.865ZM132.996 134.472C133.437 134.472 133.794 134.114 133.794 133.674C133.794 133.233 133.437 132.876 132.996 132.876C132.556 132.876 132.199 133.233 132.199 133.674C132.199 134.114 132.556 134.472 132.996 134.472ZM133.794 130.483C133.794 130.923 133.437 131.28 132.996 131.28C132.556 131.28 132.199 130.923 132.199 130.483C132.199 130.042 132.556 129.685 132.996 129.685C133.437 129.685 133.794 130.042 133.794 130.483ZM132.996 128.089C133.437 128.089 133.794 127.732 133.794 127.291C133.794 126.851 133.437 126.494 132.996 126.494C132.556 126.494 132.199 126.851 132.199 127.291C132.199 127.732 132.556 128.089 132.996 128.089ZM136.986 143.247C136.986 143.688 136.628 144.045 136.188 144.045C135.747 144.045 135.39 143.688 135.39 143.247C135.39 142.807 135.747 142.449 136.188 142.449C136.628 142.449 136.986 142.807 136.986 143.247ZM136.188 140.854C136.628 140.854 136.986 140.497 136.986 140.056C136.986 139.615 136.628 139.258 136.188 139.258C135.747 139.258 135.39 139.615 135.39 140.056C135.39 140.497 135.747 140.854 136.188 140.854ZM136.986 136.865C136.986 137.305 136.628 137.663 136.188 137.663C135.747 137.663 135.39 137.305 135.39 136.865C135.39 136.424 135.747 136.067 136.188 136.067C136.628 136.067 136.986 136.424 136.986 136.865ZM136.188 134.472C136.628 134.472 136.986 134.114 136.986 133.674C136.986 133.233 136.628 132.876 136.188 132.876C135.747 132.876 135.39 133.233 135.39 133.674C135.39 134.114 135.747 134.472 136.188 134.472ZM136.986 130.483C136.986 130.923 136.628 131.28 136.188 131.28C135.747 131.28 135.39 130.923 135.39 130.483C135.39 130.042 135.747 129.685 136.188 129.685C136.628 129.685 136.986 130.042 136.986 130.483ZM136.188 128.089C136.628 128.089 136.986 127.732 136.986 127.291C136.986 126.851 136.628 126.494 136.188 126.494C135.747 126.494 135.39 126.851 135.39 127.291C135.39 127.732 135.747 128.089 136.188 128.089Z",
  fill: "url(#paint3_linear_805_42721)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M36.011 76.3982C25.8264 80.9981 17.684 80.9398 11.5838 76.2235C5.48367 71.5071 1.62239 64.7911 0 56.0755C19.0681 50.3492 31.0718 57.1235 36.011 76.3982Z",
  fill: "url(#paint4_linear_805_42721)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.972 68.1274C18.7738 66.8803 16.3296 65.4984 13.6393 63.9817L7.39881 65.476C7.2881 65.5025 7.17694 65.434 7.15053 65.3229C7.12411 65.2117 7.19244 65.1002 7.30315 65.0737L13.1098 63.6832C9.7522 61.7908 6.0203 59.6934 1.91419 57.3908C1.81483 57.3351 1.77929 57.2091 1.83481 57.1094C1.89032 57.0097 2.01587 56.974 2.11523 57.0297C9.61252 61.2339 15.8623 64.7544 20.8648 67.5914L20.2193 61.2427C20.1914 60.9684 20.6014 60.9264 20.6293 61.2007L21.3044 67.8408C27.9741 71.6252 32.36 74.1581 34.4632 75.44C34.5605 75.4993 34.5914 75.6265 34.5324 75.7241C34.4733 75.8218 34.3465 75.8528 34.2492 75.7936C32.9908 75.0265 30.9117 73.8097 28.0122 72.1433C28.0045 72.1472 27.9966 72.1507 27.9883 72.1537L22.2853 74.2439C22.1784 74.2831 22.0601 74.2279 22.021 74.1206C21.982 74.0133 22.037 73.8946 22.1439 73.8554L27.546 71.8755C25.6926 70.8118 23.5233 69.5749 21.0379 68.1648C21.0139 68.1567 20.9914 68.1443 20.972 68.1274Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M33.7292 82.1574C23.26 78.1911 17.5279 72.387 16.5328 64.7451C15.5377 57.1033 17.5419 49.6367 22.5454 42.3455C40.1085 51.8056 43.8365 65.0762 33.7292 82.1574Z",
  fill: "url(#paint5_linear_805_42721)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M29.4171 65.7448C31.462 73.1525 32.7757 78.0552 33.3582 80.4537C33.3852 80.5647 33.3176 80.6766 33.2073 80.7037C33.097 80.7308 32.9857 80.6628 32.9588 80.5519C32.6102 79.1167 31.9988 76.7813 31.1247 73.5458C31.1166 73.5432 31.1085 73.54 31.1005 73.5363L25.6083 70.9676C25.5053 70.9195 25.4607 70.7965 25.5085 70.6929C25.5564 70.5894 25.6787 70.5445 25.7816 70.5926L30.9841 73.0258C30.4244 70.9587 29.7634 68.5451 29.0014 65.7847C28.9901 65.762 28.9829 65.7373 28.9811 65.7115C28.307 63.2702 27.5541 60.559 26.7224 57.5779L21.2698 54.2066C21.1731 54.1468 21.1429 54.0194 21.2024 53.9221C21.2618 53.8249 21.3884 53.7945 21.4852 53.8543L26.5587 56.9912C25.5203 53.2711 24.362 49.1403 23.0839 44.5991C23.0529 44.4892 23.1164 44.3749 23.2257 44.3438C23.3349 44.3127 23.4486 44.3766 23.4795 44.4865C25.8132 52.7782 27.7474 59.7014 29.2822 65.2566L33.2894 60.3102C33.4625 60.0964 33.7813 60.3577 33.6081 60.5714L29.4171 65.7448Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1523 89.3169C35.5067 96.4103 27.6326 98.4712 20.53 95.4996C13.4274 92.5281 7.97076 87.0421 4.16016 79.0415C21.0901 68.5498 34.4208 71.975 44.1523 89.3169Z",
  fill: "url(#paint6_linear_805_42721)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M27.7172 84.7121C35.1303 86.6296 40.0166 87.9331 42.377 88.6231C42.4862 88.655 42.5488 88.7695 42.517 88.8788C42.4851 88.9882 42.3708 89.0509 42.2616 89.019C40.8492 88.6062 38.5288 87.9727 35.3006 87.1187C35.2942 87.1245 35.2875 87.1299 35.2803 87.135L30.3141 90.6253C30.221 90.6907 30.0926 90.6682 30.0272 90.5749C29.9619 90.4817 29.9844 90.3531 30.0775 90.2876L34.7816 86.9815C32.7185 86.437 30.3058 85.8076 27.5434 85.0932C27.5182 85.0916 27.4933 85.0855 27.4701 85.0742C25.027 84.4425 22.3116 83.7445 19.324 82.9805L13.6854 86.0361C13.5854 86.0903 13.4604 86.0531 13.4063 85.9529C13.3522 85.8527 13.3894 85.7276 13.4894 85.6734L18.736 82.8302C15.0073 81.8772 10.8646 80.8236 6.30783 79.6694C6.19757 79.6414 6.13079 79.5293 6.15868 79.4189C6.18657 79.3084 6.29856 79.2416 6.40883 79.2695C14.729 81.3769 21.6688 83.149 27.2286 84.5858L24.9694 78.6382C24.8718 78.3812 25.2567 78.2345 25.3544 78.4915L27.7172 84.7121Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2028 88.5266H115.453C116.653 88.5266 117.625 89.4989 117.625 90.6982V151.532C117.625 152.732 116.653 153.704 115.453 153.704H11.2028C10.0035 153.704 9.03125 152.732 9.03125 151.532V90.6982C9.03125 89.4989 10.0035 88.5266 11.2028 88.5266Z",
  fill: "url(#paint7_linear_805_42721)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M9.03125 99.3894H117.625V112.425H9.03125V99.3894Z",
  fill: "#211D41"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.0937 130.892H17.7188V135.237H35.0937V130.892ZM30.75 140.668H17.7188V145.014H30.75V140.668ZM39.4375 130.892H61.1562V135.237H39.4375V130.892ZM50.2968 140.668H35.0937V145.014H50.2968V140.668Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M91.7789 145.665C95.8572 145.665 99.1632 142.358 99.1632 138.279C99.1632 134.199 95.8572 130.892 91.7789 130.892C87.7006 130.892 84.3945 134.199 84.3945 138.279C84.3945 142.358 87.7006 145.665 91.7789 145.665Z",
  fill: "#52D7FD"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M99.1656 145.665C103.244 145.665 106.55 142.358 106.55 138.279C106.55 134.199 103.244 130.892 99.1656 130.892C95.0873 130.892 91.7812 134.199 91.7812 138.279C91.7812 142.358 95.0873 145.665 99.1656 145.665Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M69.67 15.9248H207.199C209.198 15.9248 210.819 17.5452 210.819 19.5441V120.884C210.819 122.883 209.198 124.503 207.199 124.503H69.67C67.6712 124.503 66.0508 122.883 66.0508 120.884V19.5441C66.0508 17.5452 67.6712 15.9248 69.67 15.9248Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M134.092 88.3103H73.2891V117.264H134.092V88.3103ZM209.914 88.3103H141.33V117.264H209.914V88.3103Z",
  fill: "#BDDEFF"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M76.9102 102.244C76.9102 107.242 80.9611 111.293 85.9581 111.293C90.9552 111.293 95.0061 107.242 95.0061 102.244C95.0061 97.2473 90.9552 93.1963 85.9581 93.1963C80.9611 93.1963 76.9102 97.2473 76.9102 102.244ZM112.378 93.1963H99.1682V96.8156H112.378V93.1963ZM99.1682 107.673H130.474V111.293H99.1682V107.673ZM130.474 100.435H99.1682V104.054H130.474V100.435Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M159.97 111.836C164.967 111.836 169.018 107.785 169.018 102.787C169.018 97.7903 164.967 93.7393 159.97 93.7393C154.973 93.7393 150.922 97.7903 150.922 102.787C150.922 107.785 154.973 111.836 159.97 111.836Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M159.97 93.7393C154.973 93.7393 150.922 97.7903 150.922 102.787H159.97C159.97 99.0026 159.97 95.9866 159.97 93.7393Z",
  fill: "url(#paint8_linear_805_42721)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M185.302 111.836C190.299 111.836 194.35 107.785 194.35 102.787C194.35 97.7903 190.299 93.7393 185.302 93.7393C180.305 93.7393 176.254 97.7903 176.254 102.787C176.254 107.785 180.305 111.836 185.302 111.836Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M185.305 102.548C185.305 102.708 185.305 105.803 185.305 111.836C190.302 111.836 194.353 107.785 194.353 102.787C194.353 102.787 191.337 102.708 185.305 102.548Z",
  fill: "url(#paint9_linear_805_42721)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M188.923 38.0024H174.446V81.6147H188.923V38.0024ZM152.731 45.241H167.208V81.6147H152.731V45.241ZM145.493 56.6417H131.016V81.6147H145.493V56.6417ZM123.778 68.0424H109.301V81.6147H123.778V68.0424Z",
  fill: "url(#paint10_linear_805_42721)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M95.0042 38.1833H73.2891V40.8978H95.0042V38.1833ZM73.2891 46.3267H95.0042V49.0412H73.2891V46.3267ZM95.0042 54.4701H73.2891V57.1845H95.0042V54.4701ZM73.2891 62.6134H95.0042V65.3279H73.2891V62.6134ZM95.0042 70.7568H73.2891V73.4712H95.0042V70.7568ZM95.0042 78.9002H73.2891V81.6146H95.0042V78.9002Z",
  fill: "#BDDEFF"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M69.67 15.9248H207.199C209.198 15.9248 210.819 17.5452 210.819 19.5441V30.4019H66.0508V19.5441C66.0508 17.5452 67.6712 15.9248 69.67 15.9248Z",
  fill: "#3B97FC"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M206.683 151.138C207.481 150.666 208.225 150.304 208.918 150.052C209.956 149.674 210.023 150.062 210.023 150.508C210.023 150.954 210.023 151.955 210.023 152.764C210.023 153.573 209.773 153.662 208.349 153.565C206.925 153.468 206.751 153.336 205.257 153.565C203.763 153.794 200.748 153.75 200.091 152.7C199.434 151.65 201.554 151.219 203.408 150.967C204.644 150.8 205.736 150.856 206.683 151.138Z",
  fill: "#021038"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M210.018 146.39V150.719L209.079 151.086C207.374 151.753 205.469 151.693 203.809 150.92L206.104 150.425V146.39H210.018Z",
  fill: "#FE9F9F"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M226.147 148.695C226.735 147.978 227.311 147.383 227.875 146.91C228.722 146.2 228.918 146.542 229.07 146.961C229.223 147.38 229.565 148.321 229.842 149.081C230.118 149.84 229.913 150.01 228.542 150.406C227.171 150.801 226.962 150.737 225.637 151.463C224.312 152.189 221.464 153.179 220.487 152.417C219.51 151.655 221.355 150.525 223.011 149.654C224.115 149.074 225.16 148.754 226.147 148.695Z",
  fill: "#021038"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M199.212 64.4053L204.509 76.6757L195.851 83.0557L189.82 70.2957L199.212 64.4053Z",
  fill: "white"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M227.657 143.093L229.137 147.161L228.381 147.827C227.006 149.037 225.196 149.632 223.371 149.474L225.359 148.223L223.979 144.431L227.657 143.093Z",
  fill: "#FE9F9F"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M215.981 85.7722L218.285 93.3172L223.119 126.962L229.167 145.488L224.332 146.944L214.551 128.412L208.809 100.254L215.981 85.7722Z",
  fill: "#021038"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M195.334 80.3618C194.879 79.753 194.721 78.9984 194.858 78.098C194.995 77.1975 194.871 76.4925 194.485 75.9829L193.327 77.6781L191.712 74.1951C191.19 76.3766 191.19 77.9077 191.712 78.7886C192.235 79.6695 193.16 80.8503 194.485 82.3311L195.334 80.3618Z",
  fill: "#FE9F9F"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M205.46 149.09C202.841 109.777 201.531 88.8705 201.531 86.3701C201.531 82.6195 217.833 75.8403 217.833 86.3701C217.833 88.8118 217.929 91.2208 218.121 93.5971C218.388 96.8996 217.897 100.219 216.683 103.302L213.411 111.615L211.091 149.09H205.46Z",
  fill: "#312C74"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M218.638 94.9578C210.987 95.8581 208.359 96.1399 202.001 95.8654C201.742 91.4395 201.531 87.1564 201.531 86.3702C201.531 84.3058 201.162 79.0983 200.423 70.7477C200.409 70.5938 200.402 70.4395 200.402 70.2851C200.402 67.3867 202.752 65.0371 205.65 65.0371L215.03 65.0371C215.074 65.0371 215.117 65.0379 215.161 65.0396C217.079 65.112 218.574 66.7251 218.502 68.6427L217.833 86.3702C218.146 89.7448 218.414 92.6074 218.638 94.9578Z",
  fill: "url(#paint11_linear_805_42721)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M206.997 71.5115V80.6908C206.997 82.6869 206.324 84.6246 205.086 86.1904C203.955 87.6208 202.824 89.0513 201.693 90.4817C201.616 88.9676 201.532 86.7994 201.532 86.3702C201.532 85.6139 201.482 84.4359 201.383 82.836C202.865 82.836 204.736 79.0612 206.997 71.5115Z",
  fill: "#211D41"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M197.261 46.0669C196.858 44.9227 196.406 44.2386 195.905 44.0146C195.153 43.6785 194.281 42.6588 195.353 41.5732L196.092 40.9178L194.352 38.615C194.483 38.4492 195.001 38.5787 195.905 39.0035C197.261 39.6406 198.177 40.521 198.661 41.9769C199.144 43.4329 198.904 43.9809 200.529 46.35L197.809 47.1063L197.261 46.0669Z",
  fill: "#FE9F9F"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M203.532 62.4597L196.891 45.7355L200.185 44.5168L207.756 55.2641L203.532 62.4597Z",
  fill: "url(#paint12_linear_805_42721)"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M203.612 66.5758C204.198 66.5899 204.958 66.8174 205.892 67.2583C206.826 67.6993 207.275 68.5851 207.24 69.916L206.361 79.9538C206.25 81.2238 205.791 82.4387 205.036 83.4656L201.899 87.7295C201.741 87.9445 201.551 88.1339 201.335 88.2911C200.172 89.1388 198.542 88.8832 197.694 87.7201L192.98 81.2527L195.269 79.509L198.714 82.3346L200.222 80.6819C200.362 78.1398 200.432 75.0483 200.432 71.4075C200.432 67.7667 201.492 66.1561 203.612 66.5758Z",
  fill: "url(#paint13_linear_805_42721)"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M216.278 79.5331C211.995 78.6503 209.678 76.5856 209.326 73.3389C208.797 68.4689 208.318 67.6672 206.684 67.3199C205.05 66.9725 202.961 64.8929 202.961 59.8912V53.3431C202.961 50.2249 205.489 47.697 208.607 47.697H209.741C212.859 47.697 215.387 50.2249 215.387 53.3431V59.8912C215.54 62.4449 216.19 64.3214 217.337 65.5208C219.057 67.3199 221.302 69.4474 219.948 74.1353C219.046 77.2605 217.823 79.0598 216.278 79.5331Z",
  fill: "url(#paint14_linear_805_42721)"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M208.082 101.153H208.444V99.886H208.082V101.153ZM208.444 104.229H208.082V102.962H208.444V104.229ZM208.082 107.305H208.444V106.039H208.082V107.305ZM208.444 110.382H208.082V109.115H208.444V110.382ZM208.082 113.458H208.444V112.192H208.082V113.458ZM208.444 116.535H208.082V115.268H208.444V116.535ZM208.082 119.611H208.444V118.344H208.082V119.611ZM208.444 122.687H208.082V121.421H208.444V122.687ZM208.082 125.764H208.444V124.497H208.082V125.764ZM208.444 128.84H208.082V127.573H208.444V128.84ZM208.082 131.917H208.444V130.65H208.082V131.917ZM208.444 134.993H208.082V133.726H208.444V134.993ZM208.082 138.069H208.444V136.803H208.082V138.069ZM208.444 141.146H208.082V139.879H208.444V141.146ZM208.082 144.222H208.444V142.955H208.082V144.222ZM208.082 147.298H208.444V146.032H208.082V147.298Z",
  fill: "#A587FF"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M66.0326 37.3932L45.1887 52.4558L39.4375 46.3266L66.0501 33.0986L66.0326 37.3932Z",
  fill: "#221E41"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M37.5817 74.269L48.9192 81.5884L55.3613 88.5342H35.9961V78.3547L37.5817 74.269Z",
  fill: "#211D41"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M77.3311 106.592L75.7305 104.104L79.2994 102.163L80.6296 105.228L77.3311 106.592Z",
  fill: "#FE9F9F"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M76.7891 106.558L80.3844 104.565L83.0834 104.063C84.4563 103.833 85.5149 103.464 86.2207 104.737C86.402 105.064 86.3323 105.449 86.0649 105.597L79.3215 109.335C78.902 109.568 78.3733 109.416 78.1407 108.997L76.7891 106.558Z",
  fill: "#211D41"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M47.076 47.0413L41.7158 46.288L42.0041 44.2369C41.0389 42.1822 41.0509 39.519 42.04 36.2471C43.0292 32.9752 45.7986 32.4535 50.3483 34.6818C50.2071 36.6304 50.5417 37.9205 51.3522 38.5522C52.5678 39.4997 52.0958 40.1584 51.6013 40.315C51.1068 40.4716 50.753 40.8063 50.7345 41.9451C50.7161 43.0839 50.0022 43.2095 48.8763 43.5022C48.1258 43.6973 47.5257 44.877 47.076 47.0413Z",
  fill: "#E9A17C"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M41.9414 44.1835C41.4666 44.0045 41.1935 43.7075 41.1222 43.2924C41.0152 42.6699 41.3774 42.3811 40.1534 41.1007C38.9294 39.8203 37.9473 38.1283 38.728 35.1841C39.5086 32.24 41.2756 32.0007 43.0379 31.8511C44.8001 31.7015 45.5153 31.9073 47.9376 31.1162C50.3598 30.3252 51.5777 31.9016 51.0469 34.307C50.5161 36.7124 46.8757 36.6197 46.2363 36.5298C45.5969 36.4399 45.9122 37.401 45.9751 38.3886C46.038 39.3763 45.4061 39.5889 45.1754 39.4489C44.9447 39.3088 44.4544 39.145 44.007 39.6882C43.5596 40.2314 43.9938 41.0986 44.345 41.148C44.6962 41.1974 45.164 41.0966 45.1794 41.4967C45.1949 41.8968 44.9798 43.1274 44.5672 43.7766C44.2921 44.2094 43.4168 44.345 41.9414 44.1835Z",
  fill: "url(#paint15_linear_805_42721)"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M38.4238 75.7483L53.4011 77.8143L69.1482 83.1263C71.0967 83.7836 72.6851 85.2201 73.5342 87.0931L80.7311 102.968L75.3472 104.65L64.7773 90.1199L48.3839 89.7479C41.8211 89.9771 36.3151 84.8425 36.0859 78.2796L38.4238 75.7483Z",
  fill: "url(#paint16_linear_805_42721)"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M58.2695 47.744H69.2303L84.5989 40.023L86.0537 38.1833V39.8621H89.7258C89.3712 41.7695 88.6706 42.9593 87.6238 43.4314C86.5771 43.9034 85.0652 43.9034 83.0882 43.4314L69.4463 53.5416L58.2695 55.1335V47.744Z",
  fill: "#E9A17C"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M60.0981 46.9667L59.3248 55.5558L52.8341 55.7368L53.6492 77.7498L35.9965 78.3663L35.1258 53.4326C34.9793 49.2375 38.2613 45.718 42.4563 45.5715L44.8378 45.4883C46.474 45.4312 54.9416 46.4832 60.0981 46.9667Z",
  fill: "url(#paint17_linear_805_42721)"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.2644 79.4712L44.1328 79.5954C44.4335 79.914 44.7261 80.2191 45.0104 80.5108L45.1399 80.3845C44.8563 80.0935 44.5645 79.7891 44.2644 79.4712ZM46.4196 81.6602L46.294 81.7904C46.6154 82.1005 46.9241 82.3898 47.2201 82.6584L47.3417 82.5244C47.0471 82.2571 46.7397 81.969 46.4196 81.6602ZM48.6034 83.8353L48.7151 83.693C49.0833 83.982 49.4241 84.2264 49.7373 84.4263L49.6399 84.5788C49.3215 84.3756 48.976 84.1278 48.6034 83.8353ZM51.3577 85.097L51.3371 85.2768L52.5955 85.4211L52.6161 85.2413L51.3577 85.097ZM54.3933 85.6273L54.414 85.4475L55.6724 85.5918L55.6518 85.7716L54.3933 85.6273ZM57.4703 85.798L57.4496 85.9778L58.7081 86.1221L58.7287 85.9423L57.4703 85.798ZM60.5059 86.3283L60.5265 86.1485L61.785 86.2928L61.7644 86.4726L60.5059 86.3283ZM63.5828 86.499L63.5622 86.6787L64.8207 86.8231L64.8413 86.6433L63.5828 86.499ZM66.5788 87.1549L66.6354 86.983C67.0435 87.1174 67.4368 87.2924 67.8094 87.505L67.7197 87.6622C67.3576 87.4556 66.9754 87.2855 66.5788 87.1549ZM69.2539 88.6295L69.1235 88.755C69.4124 89.055 69.6709 89.3836 69.8952 89.7366L70.0479 89.6396C69.8172 89.2764 69.5511 88.9382 69.2539 88.6295ZM70.7803 91.3159L70.9387 91.2284L71.5508 92.3375L71.3924 92.4249L70.7803 91.3159ZM72.4253 93.9218L72.2668 94.0093L72.8789 95.1183L73.0373 95.0308L72.4253 93.9218ZM73.7533 96.7026L73.9118 96.6152L74.5239 97.7242L74.3654 97.8117L73.7533 96.7026ZM75.3983 99.3086L75.2399 99.396L75.8519 100.505L76.0104 100.418L75.3983 99.3086Z",
  fill: "white"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M86.6809 19.5439H115.092C115.491 19.5439 115.815 19.868 115.815 20.2678V48.6791C115.815 49.0789 115.491 49.4029 115.092 49.4029H86.6809C86.2811 49.4029 85.957 49.0789 85.957 48.6791V20.2678C85.957 19.868 86.2811 19.5439 86.6809 19.5439Z",
  fill: "#52D7FD"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.918 30.6125H101.313V32.9353L108.033 28.1398L101.313 23.3442V25.6946H93.918V30.6125ZM100.638 45.6028V43.28H108.033V38.362H100.638V36.0117L93.918 40.8072L100.638 45.6028Z",
  fill: "#2EB3DA"
});

var _ref54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_805_42721",
  x1: -4.72747,
  y1: 7.15137,
  x2: -4.72747,
  y2: 148.708,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0F6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8BE2F7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_805_42721",
  x1: 155.745,
  y1: 141.715,
  x2: 162.782,
  y2: 155.703,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CFE49F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A9D386"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_805_42721",
  x1: 184.314,
  y1: 110.941,
  x2: 184.314,
  y2: 152.649,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#55D0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#32A2FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_805_42721",
  x1: 119.434,
  y1: 126.494,
  x2: 119.434,
  y2: 144.045,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9485"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF676E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_805_42721",
  x1: -3.61882,
  y1: 63.6757,
  x2: 9.18033,
  y2: 77.3962,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CFE49F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A9D386"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_805_42721",
  x1: 18.0304,
  y1: 50.0056,
  x2: 32.1302,
  y2: 64.0601,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#77D791"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4FA67E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_805_42721",
  x1: -5.10235,
  y1: 90.2206,
  x2: 20.7633,
  y2: 115.813,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6EAE7C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0F575D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_805_42721",
  x1: 9.03125,
  y1: 88.5266,
  x2: 9.03125,
  y2: 153.704,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4DBCFA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1486DB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_805_42721",
  x1: 147.553,
  y1: 88.9481,
  x2: 147.553,
  y2: 110.629,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1533B6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#356BE9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_805_42721",
  x1: 181.936,
  y1: 97.6303,
  x2: 181.936,
  y2: 119.884,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1533B6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#356BE9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_805_42721",
  x1: 109.301,
  y1: 38.0024,
  x2: 109.301,
  y2: 81.6147,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9485"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF676E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_805_42721",
  x1: 197.907,
  y1: 56.5737,
  x2: 197.907,
  y2: 95.9661,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C0E4FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#72B9FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_805_42721",
  x1: 195.404,
  y1: 39.6069,
  x2: 195.404,
  y2: 62.4597,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C0E4FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#72B9FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_805_42721",
  x1: 191.029,
  y1: 60.4139,
  x2: 191.029,
  y2: 88.7913,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C0E4FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#72B9FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_805_42721",
  x1: 202.961,
  y1: 47.697,
  x2: 202.961,
  y2: 79.5331,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1D2A78"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#12033B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_805_42721",
  x1: 38.4492,
  y1: 30.9102,
  x2: 38.4492,
  y2: 44.2494,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1D2A78"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#12033B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_805_42721",
  x1: 19.4639,
  y1: 60.4442,
  x2: 19.4639,
  y2: 129.698,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1533B6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#356BE9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_805_42721",
  x1: 35.1211,
  y1: 45.4861,
  x2: 35.1211,
  y2: 78.3663,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9485"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF676E"
})));

function SvgFinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 154,
    viewBox: "0 0 230 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.54908313.svg";
export { ForwardRef as ReactComponent };